import { render, staticRenderFns } from "./sydg.vue?vue&type=template&id=e6bc15fa&scoped=true"
import script from "./sydg.vue?vue&type=script&lang=js"
export * from "./sydg.vue?vue&type=script&lang=js"
import style0 from "./sydg.vue?vue&type=style&index=0&id=e6bc15fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bc15fa",
  null
  
)

export default component.exports